// src/components/GlobalMedic.js
import { useState, useEffect, useContext } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import '../../styles/global-medic.css';

import { CommentUnit } from './post-item';
import { useGlobalMedic } from '../../services/global-medic/gobal-medic.context';
import { BmsHeader } from '../../components/main-components/app.header';
import { SkewBox } from "../../components/page/skew";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faShareAlt, faThumbsUp as thumbsUp, faThumbsDown as thumbsDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp, faThumbsDown, faCommentAlt } from "@fortawesome/free-regular-svg-icons";
import { formatUrl } from '../../helpers/parse-url';
import { AuthenticationContext } from '../../services/authentication/authentication.context';
import { ellispisis } from '../../helpers/utility-methods';
import { PostComments } from './post-comments';
import { Loader } from '../../components/utilities/loader';

import { TagsContainer } from '../../components/forms/tags-container';
import { AppAlert } from '../../components/utilities/alert';
import { AuthorInfo } from '../../components/global-medic/author-info';
import { AppFooter } from '../../components/main-components/footer';
import { GlobalMedicNav } from '../../components/global-medic/global-medic-nav';


const filters = ['Hot', 'Popular', 'Studies', 'Examinations', 'Nursing', 'Medical Imaging', 'Physiotherapy', 'Public Health', 'Pharmacy', 'Laboratory Science'];


function GlobalDiscussion() {

    const {
        toggleLikeDiscussion,
        toggleUnlikeDiscussion,
        deleteDiscussion,
        allDiscussions
    } = useGlobalMedic();

    const [posts, setPosts] = useState([]);
    const [sortBy, setSortBy] = useState([]); // 'new', 'top', 'hot'
    const [openedPosts, setOpenedPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [postMenu, setPostMenu] = useState(null);
    const [onAlert, setOnAlert] = useState();
    const [viewFilter, setViewFilter] = useState(false);

    const { token, userData } = useContext(AuthenticationContext);

    const navigateTo = useNavigate();

    useEffect(() => {
        const discussions = allDiscussions;
        sortBy.length > 0 ?
            setPosts(discussions?.filter((discussion) => discussion.tags.some((tag) => sortBy.includes(tag)))) :
            setPosts(discussions);
    }, [sortBy, allDiscussions]);


    const toggleCurrentLikes = async (post_id) => {
        //like post and return post object with likedArray including user _id
        const resp = await toggleLikeDiscussion(post_id, token);
        if (resp?.error) {
            alert("Something went wrong!");
            return;
        }
        //replace post in posts array with liked post
        setPosts((curr) => curr.map((p) => {
            if (p._id === post_id) {
                return resp;
            } else {
                return p;
            }
        }));
    }

    const toggleViewPost = (indx) => {
        if (openedPosts.includes(indx)) {
            setOpenedPosts((psts) => psts.filter((v) => v !== indx));
        } else {
            setOpenedPosts((psts) => ([...psts, indx]));
        }
    }

    const toggleCurrentUnlikes = async (post_id) => {
        const resp = await toggleUnlikeDiscussion(post_id, token);
        if (resp?.error) {
            alert("Something went wrong!");
            return;
        }
        setPosts((curr) => curr.map((p) => {
            if (p._id === post_id) {
                return resp;
            } else {
                return p;
            }
        }));
    }

    const removeDiscussion = async (id) => {
        try {
            setLoading(true);
            const resp = await deleteDiscussion(token, id);
            alert(resp?.message);
            window.location.reload();
        } catch (error) {
            alert("Something went wrong!")
        } finally {
            setLoading(false);
        }
    }

    const handleDelete = async (id) => {
        setPostMenu();
        setOnAlert({
            caption: "Delete Discussion",
            message: "Do you wish to delete this discussion? This action cannot be reversed.",
            accept: "Delete",
            reject: "Cancel",
            acceptAction: async () => await removeDiscussion(id),
            rejectAction: () => setOnAlert()
        });
    }


    const toggleShowFilter = () => setViewFilter((st) => !st);


    return (
        <div className="global-medic-container">
            <BmsHeader />
            <SkewBox
                title={"GLOBAL DISCUSSIONS"}
                background={"/media/global-medic.png"}
            />
            {loading && <Loader />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    acceptAction={onAlert.acceptAction}
                    rejectAction={onAlert.rejectAction}
                    close={() => setOnAlert()}
                />
            )}
            <GlobalMedicNav active={'disc'} />
            <div className="gm-content">

                {/* Main Post List */}
                <main className="gm-post-list">
                    <div className='posts'>
                        <div className='mobi-buttons'>
                            <button
                                className="mobi-filter-btn"
                                onClick={() => toggleShowFilter()}
                            >
                                <FontAwesomeIcon icon={faFilter} />
                            </button>
                        </div>
                        {posts?.length > 0 ? (
                            <>
                                <button
                                    className="add-button gl-btn"
                                    onClick={() => navigateTo("/globalmedic/creatediscussion")}
                                >
                                    <FontAwesomeIcon icon={faPlus} color='#2a88cb' className='add-ico' />
                                    <span className='st-cap'>New Post</span>

                                </button>
                                <div className="post-list-container">
                                    {posts?.map((post, indx) => (
                                        <div key={indx}>
                                            <div
                                                className={classNames(
                                                    'post-item',
                                                    { 'opened': openedPosts.includes(indx) }
                                                )}
                                                onContextMenu={() => ''}
                                            >
                                                {/* post author data and menu button */}
                                                <AuthorInfo
                                                    post={post}
                                                    closeMenu={() => setPostMenu()}
                                                    handleDelete={async () => {
                                                        await handleDelete(post?._id)
                                                    }}
                                                    selectPost={() => setPostMenu(indx)}
                                                    postMenu={postMenu}
                                                    indx={indx}
                                                    userData={userData}
                                                />

                                                <div className='post-title'>{post?.title}</div>
                                                <div
                                                    className="post-content"
                                                    dangerouslySetInnerHTML={{
                                                        __html: post?.content?.length < 250 || openedPosts.includes(indx) ?
                                                            post?.content :
                                                            ellispisis(post?.content, 250)
                                                    }}
                                                />
                                                <div>
                                                    {post?.media?.image &&
                                                        <div
                                                            className={classNames(
                                                                'post-image-box',
                                                                { 'viewed': openedPosts.includes(indx) }
                                                            )}
                                                        >
                                                            <img
                                                                src={formatUrl(post?.media?.image)}
                                                                className='post-image'
                                                                alt=''
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                                {(post?.content?.length >= 250 || post?.media?.image) &&
                                                    <button
                                                        className="more"
                                                        onClick={() => toggleViewPost(indx)}
                                                    >
                                                        {openedPosts.includes(indx) ? 'See less' : 'See more...'}
                                                    </button>
                                                }
                                                <TagsContainer tagsData={post?.tags} />
                                                <div className='reaction-box'>
                                                    <button
                                                        className="reaction-buttons"
                                                        onClick={async () => await toggleCurrentLikes(post?._id)}
                                                    >
                                                        <span className='react-cnt'>
                                                            {post?.likes?.length || ''}
                                                        </span>
                                                        <FontAwesomeIcon
                                                            icon={
                                                                post?.likes.includes(userData?._id) ?
                                                                    thumbsUp : faThumbsUp
                                                            }
                                                        />
                                                    </button>
                                                    <button
                                                        className="reaction-buttons"
                                                        onClick={async () => await toggleCurrentUnlikes(post?._id)}
                                                    >
                                                        <span className='react-cnt'>
                                                            {post?.unlikes?.length || ''}
                                                        </span>
                                                        <FontAwesomeIcon
                                                            icon={
                                                                post?.unlikes.includes(userData?._id) ?
                                                                    thumbsDown : faThumbsDown
                                                            }

                                                        />
                                                    </button>
                                                    <button
                                                        className="reaction-buttons"
                                                        onClick={() => toggleViewPost(indx)}
                                                    >
                                                        <span className='react-cnt'>
                                                            {post?.replies?.length || ''}
                                                        </span>
                                                        <FontAwesomeIcon icon={faCommentAlt} />
                                                    </button>
                                                    <button className="reaction-buttons">
                                                        <FontAwesomeIcon icon={faShareAlt} />
                                                    </button>
                                                </div>
                                                {openedPosts.includes(indx) && (
                                                    <PostComments
                                                        id={post?._id}
                                                        load={() => setLoading(true)}
                                                        unload={() => setLoading(false)}
                                                        resetcmt={async () => {
                                                            setPosts(allDiscussions);
                                                        }
                                                        }
                                                    />
                                                )}

                                                {openedPosts.includes(indx) && (
                                                    <div className='comments-section'>
                                                        {post?.replies?.map((reply) => (
                                                            <CommentUnit
                                                                post={reply}
                                                                key={reply?._id}
                                                                indx={reply?._id}
                                                                setLoading={setLoading}
                                                            />
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            <hr />
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <>
                                <p className='nothing-found'>
                                    No posts found. Be the first to start a discussion!
                                </p>
                                <button
                                    className="add-button"
                                    onClick={() => window.location.href = "/globalmedic/creatediscussion"}
                                >
                                    <span className='st-cap'>Start a Discussion</span>
                                    <FontAwesomeIcon icon={faPlus} color='#2a88cb' className='add-ico' />
                                </button>
                            </>
                        )}
                    </div>
                </main>
                <aside
                    className={classNames(
                        'gm-sidebar filter-bar',
                        { 'view-filter': viewFilter }
                    )}
                >
                    <p className='nothing-found'>
                        Filter By
                    </p>
                    <div className="filter-buttons">
                        {filters.map((f, k) => (
                            <button
                                className={classNames(
                                    "filters-button",
                                    { 'chosen': sortBy.includes(f) }
                                )}
                                key={k}
                                onClick={() => {
                                    if (sortBy.includes(f)) {
                                        setSortBy((arr) => arr.filter((entr) => entr !== f));
                                    } else {
                                        setSortBy((arr) => ([...arr, f]));
                                    }
                                }}
                            >
                                {f}
                            </button>
                        ))}
                    </div>
                </aside>
            </div>
            <AppFooter />
        </div>
    );
}

export default GlobalDiscussion;